import AVTPopup from './components/avt-popup';
import Simplebar from "simplebar";
import sliders from './components/sliders';
import IframeResizer from './components/IframeResizer';
import xhrwrap from "./components/xhrWrap";
import newsletter from './components/newsletter';
import offers from  "./components/offers";
import Swiper from 'swiper';
import selectMenu from "./components/select-menu";
import LazyLoad from "./components/imageLazyLoad";

const XHRWrap = xhrwrap();

document.addEventListener('DOMContentLoaded',function() {

    newsletter();
    sliders(Swiper);
    offers(Swiper);
    selectMenu(Simplebar);
    const lazyLoader = new LazyLoad('.lazy');

    const returnBtn = document.getElementById("return-top");
    if (returnBtn) {
        window.addEventListener("scroll", function(){
            if (window.scrollY > document.querySelector("html body").clientHeight / 10) {
                returnBtn.classList.add("show");
            }
            else {
                returnBtn.classList.remove("show");
            }
        }, {passive: true});
        returnBtn.addEventListener("click", function(){
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        })
    }

    const connectedBtn = document.getElementsByClassName('single-article__connected-btn-wrapper')[0];
    const connectedHidden = document.querySelector('.single-article__connected .hidden');
    const connectedBtnText = document.getElementsByClassName('single-article__connected-btn-wrapper-text')[0];

    if(connectedBtn) {
        connectedBtn.addEventListener('click',function() {
            if(connectedHidden.classList.contains('show')) {
                connectedHidden.classList.remove('show');
                if(connectedBtnText) {
                    connectedBtnText.innerHTML = '+ Wczytaj więcej';
                }
            } else {
                connectedHidden.classList.add('show');
                if(connectedBtnText) {
                    connectedBtnText.innerHTML = '- Wczytaj mniej';
                }
            }
        })
    }

    // Burger menu

    const burgerIcon = document.getElementsByClassName('burger-js');
    const burgerWrapper = document.getElementsByClassName('burger-menu')[0];
    const closeBurger = document.getElementsByClassName('burger-menu__wrapper-close')[0];
    const burgerRight = document.getElementsByClassName('burger-menu__wrapper')[0];

    if(burgerIcon) {
        for(var i = 0; i < burgerIcon.length; i++) {
            burgerIcon[i].addEventListener('click',function(){
                if(burgerWrapper.classList.contains('show')) {
                    burgerWrapper.classList.remove('show');
                } else {
                    burgerWrapper.classList.add('show');
                }
            })
        }
    }

    if(closeBurger) {
        closeBurger.addEventListener('click',function() {
            if(burgerWrapper.classList.contains('show')) {
                burgerWrapper.classList.remove('show');
            } else {
                burgerWrapper.classList.add('show');
            }
        })
    }

    if(burgerWrapper) {
        burgerWrapper.addEventListener('click', function(target) {
            if(target.target.classList.contains('burger-menu')) {
                if(burgerWrapper.classList.contains('show')) {
                    burgerWrapper.classList.remove('show');
                } else {
                    burgerWrapper.classList.add('show');
                }
            }
        })
    }

    // Toc

    const toc = document.getElementsByClassName('toc')[0];

    if(toc) {
        const tocTitle = toc.getElementsByClassName('toc__top-title')[0];
        const tocBurger = toc.getElementsByClassName('toc__top-title-lines')[0];
        const tocList   = toc.getElementsByClassName('toc__list')[0];
        let tocListHeight = tocList.getBoundingClientRect().height;

        if(tocList) {
            tocList.style.maxHeight = tocListHeight + 'px';
        }
        console.log(tocListHeight)
        if(tocTitle) {
            tocTitle.addEventListener('click',function(){
                if(tocBurger) {
                    if(tocBurger.classList.contains('closed')) {
                        tocBurger.classList.remove('closed');
                    } else {
                        tocBurger.classList.add('closed');
                    }
                }
                if(tocList) {
                    if(tocList.classList.contains('hidden')) {
                        tocList.classList.remove('hidden');
                    } else {
                        tocList.classList.add('hidden');
                    }
                }
            })
        }
    }

    // Toc scroll

    const tocItems = document.getElementsByClassName('toc__list-item');

    if(tocItems) {
        for(var i = 0; i < tocItems.length; i++) {
            tocItems[i].addEventListener('click',function(el) {
                el.preventDefault();
                let idString = this.getAttribute('href');
                const getIdElement = document.querySelector(idString);
                window.scroll({
                    top: getIdElement.offsetTop + 90,
                    left: 0,
                    behavior: 'smooth'
                });
            })
        }
    }

    // socials right bottom

    const socialsWrapper = document.getElementsByClassName('socials-bottom-js')[0];
    const socialsBtn = document.querySelector('.socials-bottom-js .socials-left__item.share');

    if(socialsBtn) {
        socialsBtn.addEventListener('click',function() {
            if(socialsWrapper.classList.contains('show')) {
                socialsWrapper.classList.remove('show');
            } else {
                socialsWrapper.classList.add('show');
            }
        })
    }

    // Poprawianie tagów code

    var codeTags = document.querySelectorAll('div[class^="language-"], div[class*=" language-"], pre[class^="language-"], pre[class*=" language-"]');

    if(codeTags) {
        for(var i = 0; i < codeTags.length; i++) {
            let nodeName;
            let text;
            if (codeTags[i].innerHTML.indexOf('\n') != -1) {
                text = codeTags[i].innerHTML.split('\n').join('</code>\n<code>');
            }
            else if (codeTags[i].innerHTML.indexOf('<br>') != -1) {
                text = "<code>" + codeTags[i].innerHTML.split('<br>').join('</code>\n<code>') + "</code>";
            }
            else if (codeTags[i].innerHTML.indexOf('</br>') != -1) {
                text = "<code>" + codeTags[i].innerHTML.split('</br>').join('</code>\n<code>') + "</code>";
            } else {
                text = codeTags[i].innerHTML ;
            }
            codeTags[i].innerHTML = '';
            codeTags[i].innerHTML = text;
        }
    }

    // Wyszukiwarka header

    var searchBtn = document.querySelectorAll('.header__icons-item.search');
    var searchMainWrapper = document.getElementsByClassName('header-search-wrapper');

    window.addEventListener('click', function(e){
        for(var i = 0; i < searchMainWrapper.length; i++) {
            if (!searchMainWrapper[i].contains(e.target)){
                searchMainWrapper[i].classList.remove('show');
            }
        }
    });


    if(searchBtn) {
        for(var i = 0; i < searchBtn.length; i++) {
            searchBtn[i].addEventListener('click',function() {
                if(this.parentNode.classList.contains('show')) {
                    this.parentNode.classList.remove('show');
                } else {
                    this.parentNode.classList.add('show');
                }
            })
        }
    }

    // Dropdown selects subpages:

    const subpageSelect = document.getElementsByClassName('subpage-category-select')[0];

    if(subpageSelect) {
        const selectWrapper = subpageSelect.getElementsByClassName('category-select')[0];
        console.log(selectWrapper)
        subpageSelect.addEventListener('click',function(){
            if(selectWrapper.classList.contains('active')) {
                selectWrapper.classList.remove('active');
            } else {
                selectWrapper.classList.add('active');
            }
        })
    }

    // Search subpage clean input

    const cleanBtn = document.getElementsByClassName('search-wrapper__form-icons-close')[0];
    const inputSearch = document.querySelector('.search-wrapper__form-input input');

    if(cleanBtn) {
        cleanBtn.addEventListener('click',function(){
            inputSearch.value = '';
        })
    }

    const popupSettings = {
        imageClass: ".imagesInContent",
        description: true,
        gallery: true,
        nextPrev: true,
        counter: true,
        zoom: false,
        excludedItems: {
            class: [],
            data: ["data-oryginal"],
            id: []
        }
    }

    // Sticky header

    var header = document.getElementsByClassName('header-js')[0];
    var showBuyBtnMagazine = document.getElementsByClassName('single-magazine__right-number-buy')[0];

    if(header) {
        window.addEventListener('scroll', () => {
            const currentScroll = window.pageYOffset;
            if(currentScroll > 250) {
                header.classList.add('header-show');
                if(showBuyBtnMagazine) {
                    showBuyBtnMagazine.classList.add('show');
                }
            } else {
                header.classList.remove('header-show');
                if(showBuyBtnMagazine) {
                    showBuyBtnMagazine.classList.remove('show');
                }
            }
        })
    }

    // magazine detect slide moment - START

    const links = document.querySelectorAll('.single-magazine__right-toc-list-item');
    const sections = document.querySelectorAll('.single-magazine__toc-title');

    if(links.length > 0) {
        function changeLinkState() {
            let index = sections.length;

            while(--index && window.scrollY + 175 < sections[index].offsetTop) {}
            links.forEach((link) => link.classList.remove('active'));
            links[index].classList.add('active');
        }

        changeLinkState();
        for(let i = 0; i < links.length; i++) {
            links[i].addEventListener('click', function(event){
                for(let j =0; j < sections.length; j++) {
                    if(sections[j].classList.contains(this.dataset.active)) {
                        window.scroll({
                            top : sections[j].offsetTop -74,
                            left : 0,
                            behavior : 'smooth'
                        });
                    }
                }
            })
        }
        window.addEventListener('scroll', changeLinkState);
    }

    // Contact form

    const contactSubmit = document.querySelector('.contact__wrapper-form');
    let statusWrapperMain = document.querySelector('.contact__wrapper-status-info');
    let statusWrapper = document.querySelector('.contact__wrapper-status-info-text');
    let sendContact;

    if(contactSubmit) {
        contactSubmit.addEventListener('submit',function(e) {
            e.preventDefault();
            e.stopPropagation();
            statusWrapperMain.classList.remove('show');
            statusWrapperMain.classList.remove('error');
            fetch("/api/v1/contact/", {
                method: "POST",
                body: new FormData(this),
            })
                .then(res => res.json())
                .then(
                    result => {
                        console.log(result);
                        if(result.status === true) {
                            if(statusWrapper) {
                                statusWrapperMain.classList.add('show');
                                statusWrapper.innerHTML = result.message.send;
                            }
                        }
                        else {
                            if(statusWrapper) {
                                statusWrapperMain.classList.add('show');
                                statusWrapperMain.classList.add('error');
                                const messageArr = [];
                                for (var message in result.message) {
                                    if (result.message.hasOwnProperty(message)) {
                                        messageArr.push(result.message[message]);
                                    }
                                }
                                console.log(messageArr);
                                statusWrapper.innerHTML = messageArr.join(", ");
                            }
                        }
                    }
                )
                .catch(err => console.log(err))
        })
    }

})
